import React from 'react'
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css"

function Docs() {
  return <SwaggerUI url="https://navrhnisitricko.sk/rest/docs.json" />
}

export default Docs;